import { render, staticRenderFns } from "./CompetitionDateTime.vue?vue&type=template&id=bd089542&scoped=true"
import script from "./CompetitionDateTime.vue?vue&type=script&lang=js"
export * from "./CompetitionDateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd089542",
  null
  
)

export default component.exports